function useShowGdpr() {
    return window.location.pathname.toLowerCase().includes('terms-and-conditions');
}

export default useShowGdpr;
